import { useNavigate } from 'react-router-dom';
import InfluencerHeader from './InfluencerHeader';
import Navbar from './Navbar';

const PartnerBrands = () => {
  const navigate = useNavigate();

  const brands = [
    {
      name: 'Amazon',
      image: 'https://i.postimg.cc/XN2KKdTy/amazonlogo.jpg',
      link: '/amazonproducts'
    },
    {
      name: 'Walmart',
      image: 'https://i.postimg.cc/d3kWFwJC/walmart.png',
      link: '/walmart'
    },
    {
      name: 'flipkart',
      image: 'https://i.postimg.cc/wjRkjM4R/flipkartlogo.jpg',
      link: '/commingsoon'
    }
  ];

  return (
    <div className="flex flex-col h-screen">
      {/* Top Header */}
      <div className="fixed top-0 left-0 right-0 z-10 bg-white shadow-md">
        <InfluencerHeader page="Explore Brands" />
      </div>

      <div className="flex flex-1 pt-20">
        {/* Sidebar */}
        <div className="fixed top-0 left-0 bottom-0 w-0 z-20">
          <Navbar />
        </div>

        {/* Main Contents */}
        <div className="flex-1 ml-10 p-6 flex flex-col items-center mt-12">
          <h1 className="text-3xl font-bold text-black mb-10 text-center mb-12">
            Explore Brands
          </h1>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 w-full max-w-6xl mt-12">
            {brands.map((brand, index) => (
              <div
                key={index}
                onClick={() => navigate(brand.link)}
                className="cursor-pointer flex flex-col items-center justify-center bg-white rounded-2xl shadow-lg p-6 hover:shadow-2xl transition transform hover:scale-105"
              >
                <img
                  src={brand.image}
                  alt={brand.name}
                  className="w-48 h-48 object-contain rounded-full mb-4"
                />
                <h2 className="text-xl font-semibold text-gray-800">{brand.name}</h2>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerBrands;
